import { render, staticRenderFns } from "./SweetModal.vue?vue&type=template&id=d3491394&"
import script from "./SweetModal.vue?vue&type=script&lang=js&"
export * from "./SweetModal.vue?vue&type=script&lang=js&"
import style0 from "./SweetModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports